// @ts-nocheck
import _ from "lodash";

import { v4 as uuidv4 } from "uuid";

import Storage from "core/Storage";

import STORAGE from "../constants/STORAGE";

import _defaultsTo from "./_defaultsTo";

const getClientUniqueId = (): string => {
  const clientUniqueId = _defaultsTo(
    Storage.Local.get(STORAGE.clientUnique),
    Storage.Cookie.get(STORAGE.clientUnique),
    Storage.Session.get(STORAGE.clientUnique),
    uuidv4()
  );

  _.defer((id) => {
    Storage.Local.set(STORAGE.clientUnique, id);
    Storage.Cookie.set(STORAGE.clientUnique, id);
    Storage.Session.set(STORAGE.clientUnique, id);
  }, clientUniqueId);

  return clientUniqueId;
};


export default getClientUniqueId;
